/**
 * ZION — code de bienvenue : popup d'accueil, barre de panier, passage au checkout.
 *
 * Le code est délivré par le serveur (api/promo.js), il porte sa propre
 * signature et sa propre expiration. Ici on ne fait que le garder, l'afficher,
 * le décompter et le transmettre au checkout maison : aucune remise n'est
 * calculée dans le navigateur, le total vient toujours du serveur.
 *
 * L'expiration est VRAIE. À zéro le code est réellement refusé par le serveur,
 * et la barre le dit au lieu de laisser croire qu'il marche encore. C'est la
 * même règle que le chrono « Sélection gardée » : un compte à rebours qui ment
 * se teste en trente secondes et coûte plus cher que l'urgence ne rapporte.
 *
 * Script classique (pas un module) : il tourne sur toutes les pages, y compris
 * là où les composants Horizon ne sont pas chargés.
 */
(function () {
  'use strict';

  var API = 'https://checkout.zioneyewear.com/api/promo';
  var CLE = 'zion_promo';        // { code, expire }
  var CLE_VU = 'zion_promo_vu';  // horodatage de la dernière fermeture
  var CLE_STAFF = 'zion_staff';  // appareils internes, jamais de popup
  var REPOS_MS = 7 * 864e5;      // fermé sans donner son adresse : on laisse 7 jours
  var DELAI_OUVERTURE = 12000;   // 12 s : le temps de voir la page avant d'être interrompu
  var CHECKOUT = 'checkout.zioneyewear.com';

  // --- petits utilitaires ---------------------------------------------------
  function lire(cle) {
    try { return JSON.parse(localStorage.getItem(cle) || 'null'); } catch (e) { return null; }
  }
  function ecrire(cle, valeur) {
    try { localStorage.setItem(cle, JSON.stringify(valeur)); } catch (e) { /* navigation privée */ }
  }
  function oublier(cle) {
    try { localStorage.removeItem(cle); } catch (e) { /* ignoré */ }
  }
  var $ = function (sel, racine) { return (racine || document).querySelector(sel); };
  var $$ = function (sel, racine) {
    return Array.prototype.slice.call((racine || document).querySelectorAll(sel));
  };

  /** Le code retenu, ou null s'il n'y en a pas / s'il est expiré. */
  function codeActif() {
    var p = lire(CLE);
    if (!p || !p.code || !p.expire) return null;
    return Date.now() < p.expire ? p : null;
  }

  /** Utilisé par zion-cart.js pour accrocher le code à l'URL du checkout, et par
      l'accroche de la fiche produit pour rouvrir le popup à la demande. */
  window.zionPromo = {
    actif: codeActif,
    parametre: function () {
      var p = codeActif();
      return p ? '&promo=' + encodeURIComponent(p.code) : '';
    },
    ouvrir: function () { /* remplacé plus bas quand le popup existe sur la page */ }
  };

  // Appareils internes (téléphone de Larry, du livreur) : marqués une fois avec
  // ?zion=staff, ils ne verront plus jamais le popup. Même convention que l'affluence.
  try {
    if (new URLSearchParams(location.search).get('zion') === 'staff') ecrire(CLE_STAFF, 1);
  } catch (e) { /* ignoré */ }
  var staff = !!lire(CLE_STAFF);

  // --- compte à rebours partagé --------------------------------------------
  // Un seul minuteur pour toute la page : les barres du panier sont recréées à
  // chaque morph du tiroir, un minuteur par élément laisserait des orphelins.
  var vocalDit = {};

  // Au-delà d'une heure on affiche « 23 h 47 » : un compte à rebours à la seconde
  // sur 24 heures est illisible et met une pression que la durée ne justifie pas.
  // Dans la dernière heure on repasse aux minutes et aux secondes, là où le
  // client a vraiment besoin de savoir.
  function tempsRestant(ms) {
    var s = Math.max(0, Math.round(ms / 1000));
    if (s >= 3600) {
      var h = Math.floor(s / 3600);
      return h + ' h ' + ('0' + Math.floor((s % 3600) / 60)).slice(-2);
    }
    return Math.floor(s / 60) + ':' + ('0' + (s % 60)).slice(-2);
  }

  function battement() {
    var p = lire(CLE);
    var barres = $$('[data-zion-promo-barre]');
    var boite = $('[data-zion-bienvenue]');
    var reste = p && p.expire ? p.expire - Date.now() : -1;
    var vivant = !!p && reste > 0;

    document.documentElement.classList.toggle('zion-promo-actif', vivant);

    if (!p) {
      barres.forEach(function (b) { b.hidden = true; });
      return;
    }

    // Expiré : on l'annonce une fois, puis on efface. Le client ne doit pas
    // découvrir au checkout que sa remise a disparu.
    if (!vivant) {
      barres.forEach(function (b) {
        b.hidden = false;
        b.setAttribute('data-expire', '1');
        b.removeAttribute('data-fin');
        var gain = $('[data-promo-gain]', b);
        var temps = $('.zion-promo__temps', b);
        var ou = $('.zion-promo__ou', b);
        var code = $('[data-promo-code]', b);
        var jauge = $('[data-promo-jauge]', b);
        if (gain) gain.textContent = 'Code expiré';
        if (temps) temps.textContent = '';
        // « Déduits à l'étape suivante » n'a plus de sens une fois le code mort :
        // le laisser afficherait deux phrases qui se contredisent.
        if (ou) ou.textContent = 'Ta commande repart au prix habituel.';
        if (code) code.textContent = '';
        if (jauge) jauge.style.transform = 'scaleX(0)';
      });
      if (reste < -20000) { oublier(CLE); }   // laissé 20 s à l'écran, puis effacé
      return;
    }

    var duree = p.duree || 24 * 3600000;
    barres.forEach(function (b) {
      b.hidden = false;
      b.removeAttribute('data-expire');
      // Réchauffement dans la dernière demi-heure. Sur un code de 24 heures,
      // alerter à la dernière minute n'aiderait personne : à ce stade le client
      // n'est plus devant son écran depuis longtemps.
      if (reste <= 30 * 60000) b.setAttribute('data-fin', '1'); else b.removeAttribute('data-fin');
      var chrono = $('[data-promo-chrono]', b);
      var code = $('[data-promo-code]', b);
      var jauge = $('[data-promo-jauge]', b);
      if (chrono) chrono.textContent = tempsRestant(reste);
      if (code && code.textContent !== p.code) code.textContent = p.code;
      if (jauge) jauge.style.transform = 'scaleX(' + Math.max(0, Math.min(1, reste / duree)) + ')';
      annoncer(b, reste);
    });

    if (boite && boite.open) {
      var c = $('[data-bv-chrono]', boite);
      if (c) c.textContent = tempsRestant(reste);
    }
  }

  // Accroche de la fiche produit. Elle vit sa propre vie : elle doit s'afficher
  // même sans code en cours, là où la barre du panier, elle, n'a rien à dire.
  function majAccroche() {
    var accroches = $$('[data-zion-promo-fiche]');
    if (!accroches.length) return;
    var p = codeActif();
    var vu = lire(CLE_VU);
    var dejaServi = !!(vu && vu.pour === 'toujours');
    var popupDispo = !!$('[data-zion-bienvenue]');

    accroches.forEach(function (a) {
      var texte = $('[data-promo-fiche-texte]', a);
      var lien = $('[data-promo-fiche-ouvrir]', a);
      if (p) {
        // Code en cours : on le rappelle ici, c'est le moment où il décide.
        a.hidden = false;
        if (lien) lien.hidden = true;
        if (texte) texte.innerHTML = 'Ton code de bienvenue <b>−1 000 XPF</b> s’applique à ta commande · ' +
          'encore <span data-promo-fiche-temps>' + tempsRestant(p.expire - Date.now()) + '</span>';
        return;
      }
      // Code déjà pris et expiré : on n'en redonne pas un second, et on ne fait
      // pas miroiter une offre qui n'existe plus pour ce visiteur.
      if (dejaServi || staff || !popupDispo) { a.hidden = true; return; }
      a.hidden = false;
      if (texte) texte.innerHTML = 'Première commande ? <b>1 000 XPF de moins</b> sur ta paire.';
      if (lien) lien.hidden = false;
    });
  }

  // Lecteurs d'écran : aux paliers seulement. Annoncer chaque seconde reviendrait
  // à parler par-dessus tout le reste de la page pendant une demi-heure.
  function annoncer(barre, reste) {
    var vocal = $('[data-promo-vocal]', barre);
    if (!vocal) return;
    var min = Math.ceil(reste / 60000);
    var palier = min === 1440 ? 1440 : min === 60 ? 60 : min === 15 ? 15 : min === 5 ? 5 : 0;
    if (!palier || vocalDit[palier]) return;
    vocalDit[palier] = true;
    vocal.textContent = 'Code de bienvenue : ' + (
      palier === 1440 ? '24 heures restantes.' :
      palier === 60 ? 'une heure restante.' :
      palier + ' minutes restantes.');
  }

  setInterval(function () { battement(); majAccroche(); }, 1000);

  // Le clic est délégué : l'accroche peut être reconstruite par le thème.
  document.addEventListener('click', function (ev) {
    var b = ev.target && ev.target.closest ? ev.target.closest('[data-promo-fiche-ouvrir]') : null;
    if (!b) return;
    ev.preventDefault();
    if (window.zionPromo && window.zionPromo.ouvrir) window.zionPromo.ouvrir();
  });

  // --- passage du code au checkout maison -----------------------------------
  // Le lien « Commander » est reconstruit par le thème à chaque morph du tiroir :
  // on l'intercepte au clic plutôt que de réécrire un href qui sera remplacé.
  document.addEventListener('click', function (ev) {
    var lien = ev.target && ev.target.closest ? ev.target.closest('a[href]') : null;
    if (!lien) return;
    var p = codeActif();
    if (!p) return;
    var url;
    try { url = new URL(lien.href, location.href); } catch (e) { return; }
    if (url.hostname !== CHECKOUT || url.searchParams.get('promo')) return;
    url.searchParams.set('promo', p.code);
    lien.href = url.toString();
  }, true);

  // --- popup ----------------------------------------------------------------
  var boite = $('[data-zion-bienvenue]');
  if (!boite) return;

  var form = $('[data-bv-form]', boite);
  var champ = $('[data-bv-email]', boite);
  var envoi = $('[data-bv-envoi]', boite);
  var erreur = $('[data-bv-erreur]', boite);
  var ouvert = false;

  function montrerErreur(texte) {
    if (!erreur) return;
    erreur.textContent = texte;
    erreur.hidden = !texte;
    if (champ) champ.setAttribute('aria-invalid', texte ? 'true' : 'false');
  }

  function ouvrir(force) {
    // `force` : ouverture réclamée par le visiteur depuis la fiche produit. Les
    // conditions d'ouverture automatique ne s'appliquent pas à un clic.
    if (!force && (ouvert || !peutOuvrir())) return;
    if (boite.open) return;
    ouvert = true;
    try { boite.showModal(); } catch (e) { return; }
    if (champ) setTimeout(function () { champ.focus(); }, 60);
  }
  window.zionPromo.ouvrir = function () { ouvrir(true); };

  function fermer(donne) {
    // Fermé sans rien laisser : on ne le remontre pas avant sept jours.
    // Adresse donnée : plus jamais, sinon le code de bienvenue deviendrait une
    // remise permanente pour qui rouvre la page.
    ecrire(CLE_VU, donne ? { pour: 'toujours' } : { t: Date.now() });
    try { boite.close(); } catch (e) { /* déjà fermé */ }
  }

  function peutOuvrir() {
    if (staff || codeActif()) return false;
    var vu = lire(CLE_VU);
    if (vu && (vu.pour === 'toujours' || Date.now() - (vu.t || 0) < REPOS_MS)) return false;
    // Jamais par-dessus le tiroir panier ou une autre fenêtre déjà ouverte :
    // interrompre quelqu'un qui est en train de commander ne rapporte rien.
    if ($('dialog[open]:not([data-zion-bienvenue])')) return false;
    if (document.body.classList.contains('cart-drawer-open')) return false;
    return true;
  }

  if (peutOuvrir()) {
    var minuteur = setTimeout(ouvrir, DELAI_OUVERTURE);

    // Desktop : la souris qui remonte vers la barre d'adresse annonce un départ.
    document.addEventListener('mouseout', function (ev) {
      if (ev.clientY > 6 || ev.relatedTarget || ouvert) return;
      clearTimeout(minuteur);
      ouvrir();
    });

    // Mobile : pas d'intention de sortie détectable, on attend une vraie lecture.
    var auScroll = function () {
      var h = document.documentElement;
      var avance = (h.scrollTop + window.innerHeight) / Math.max(1, h.scrollHeight);
      if (avance < 0.55) return;
      window.removeEventListener('scroll', auScroll);
      clearTimeout(minuteur);
      ouvrir();
    };
    window.addEventListener('scroll', auScroll, { passive: true });
  }

  $$('[data-bv-fermer]', boite).forEach(function (b) {
    b.addEventListener('click', function () { fermer(false); });
  });
  // Clic sur le fond : la zone du <dialog> hors de son cadre.
  boite.addEventListener('click', function (ev) {
    if (ev.target === boite) fermer(false);
  });
  boite.addEventListener('cancel', function () { fermer(false); });   // touche Échap

  if (form) form.addEventListener('submit', function (ev) {
    ev.preventDefault();
    var email = (champ && champ.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(email))
      return montrerErreur('Vérifie ton adresse : il manque quelque chose.');
    montrerErreur('');
    if (envoi) { envoi.setAttribute('aria-busy', 'true'); envoi.textContent = 'Un instant…'; }

    fetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email })
    })
      .then(function (r) {
        // « Failed to fetch » ne veut rien dire pour un client. On dit ce qui se
        // passe et quoi faire, sans jamais laisser croire que le code est perdu.
        return r.json().catch(function () { throw new Error('Réessaie dans un instant.'); });
      }, function () {
        throw new Error('Connexion interrompue. Vérifie ton réseau et réessaie.');
      })
      .then(function (d) {
        if (d && d.deja) {
          // Client connu : on ne lui donne pas un code de bienvenue, et on le lui
          // dit sans le renvoyer bredouille.
          montrerErreur('Tu fais déjà partie de la maison : ce code est réservé aux nouveaux clients.');
          return;
        }
        if (!d || !d.code) throw new Error(d && d.erreur ? d.erreur : 'Réessaie dans un instant.');
        ecrire(CLE, { code: d.code, expire: d.expire, duree: d.expire - Date.now() });
        var etapeOffre = $('[data-bv-etape="offre"]', boite);
        var etapeCode = $('[data-bv-etape="code"]', boite);
        var affiche = $('[data-bv-code]', boite);
        if (affiche) affiche.textContent = d.code;
        if (etapeOffre) etapeOffre.hidden = true;
        if (etapeCode) etapeCode.hidden = false;
        ecrire(CLE_VU, { pour: 'toujours' });
        battement();
      })
      .catch(function (e) { montrerErreur(e.message || 'Réessaie dans un instant.'); })
      .then(function () {
        if (envoi) { envoi.removeAttribute('aria-busy'); envoi.textContent = 'Je prends mon code'; }
      });
  });

  // Le bouton « Voir les lunettes » ferme proprement avant de naviguer.
  var suite = $('[data-bv-suite]', boite);
  if (suite) suite.addEventListener('click', function () { fermer(true); });

  battement();
  majAccroche();
})();
